export default __webpack_public_path__ + "static/media/element_46.92f81679.webp";